<carousel #carousel [interval]="0" [(activeSlide)]="activeSlideIndex" [ngClass]="cardRowClass" *ngIf="!!products && products.length > 0">
    <slide *ngFor="let slide of slideItems; trackBy: trackByFn">
        <div class="horizontal-scroll-product-row">
            <ng-container *ngFor="let product of slide; trackBy: trackByFn">
                <product-card [product]="product"
                              [cardClass]="'horizontal-featured-products-row'"
                              [shareOptions]="shareOptions"
                              [hideStrikeThroughPricing]="true"
                              [primaryActionsTemplate]="showAddToCart ? primaryActionsTemplate : null">
                </product-card>
                <ng-template #primaryActionsTemplate>
                    <button #buttonElement class="button button-medium"
                            (click)="addProductToCart(product, buttonElement)"
                            *ngIf="showAddToCartButton$(product) | async">
                        <span class="hidden-mobile" translate="cart.product.catalog.gridview.addtocart"></span>
                        <i class="hidden-desktop fa-solid fa-cart-plus" aria-hidden="true"></i>
                    </button>
                </ng-template>
            </ng-container>
        </div>
    </slide>
</carousel>
